import { SVGProps, Ref, forwardRef } from 'react';

export const MagnifierOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.8 11c0-2.233.562-4.272 1.77-5.723C5.73 3.885 7.683 2.8 11 2.8s5.27 1.085 6.43 2.477c1.208 1.45 1.77 3.49 1.77 5.723s-.562 4.272-1.77 5.723C16.27 18.115 14.317 19.2 11 19.2s-5.27-1.085-6.43-2.477C3.362 15.273 2.8 13.233 2.8 11M1 11C1 6 3.5 1 11 1s10 5 10 10c0 2.418-.585 4.837-2.038 6.69l4.034 4.034-1.272 1.272-4.026-4.025C16.142 20.22 13.96 21 11 21 3.5 21 1 16 1 11"
                fill="currentColor"
            />
        </g>
    </svg>
));
MagnifierOutlinedSize24Glyph.displayName = 'MagnifierOutlinedSize24Glyph';
